<template>

  <div :class="['mt-6 ml-4 flex space-between space-x-4 justify-between m-2 mr-4 flex-end', isRTL === true ? 'flex-direction-row' : '']">
    <div :class="[isRTL === true ? 'text-right' : 'text-left']">
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
        {{ t('usersPage.title') }}
      </h1>
      <h1 class="text text-gray-900 dark:text-gray-200">
        {{ t('usersPage.subtitle') }}
      </h1>
    </div>

    <div class="flex">
      

      <label class="input input-bordered flex items-center mr-2" style="width:330px">
        <input type="text" v-model="searchValue" class="grow" :placeholder="t('usersPage.searchPlaceholder')" />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="h-4 w-4 opacity-70">
          <path fill-rule="evenodd"
            d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
            clip-rule="evenodd" />
        </svg>
      </label>
      
      
      <button v-if="canCreateUser != false" class="btn" @click="openUserModal()" style="background-color:#e9e9e9;">{{ t('usersPage.addNewUserButton') }}</button>

    </div>
  </div>
  
 
  <div class="mt-6 px-4">
    <ThemeOnly theme="modern" :invert="true">
      <div
        class="overflow-x-auto text-align card shadow bg-white dark:bg-gray-800 w-full rounded-md p-3 border dark:border-gray-700 flex"
        style="border-radius: 10px; width:98%;height: 70vh;">
        <EasyDataTable :headers="headers" :items="users" buttons-pagination :search-field="searchFields"
    :search-value="searchValue">
      <template #item-isactive="{ isactive }">
        <span :class="['badge', isactive!==null && isactive ? 'badge-success text-white' : 'badge-error text-white']">
          {{ isactive!==null && isactive ? t('usersPage.statusActive') : t('usersPage.statusInactive') }}
        </span>
      </template>
      <template #item-roles="{ roles }">
        <div class="flex flex-wrap space-x-2">
          <span v-if="roles.length === 0" class="px-2 py-1 text-sm rounded-full bg-red-100 text-red-800">
            {{ t('usersPage.noRoleBadge') }}
          </span>
          <span v-else v-for="role in roles" :key="role.roleid" class="px-2 py-1 text-sm rounded-full bg-blue-100 text-blue-800">
            {{ role.rolename }}
          </span>
        </div>
      </template>
      <template #item-divisions="{ divisions }">
        <div class="flex flex-wrap space-x-2">
          <span v-if="divisions != undefined && divisions.length === 0" class="px-2 py-1 text-sm rounded-full bg-red-100 text-red-800">
            {{ t('usersPage.noDivisionBadge') }}
          </span>
          <span v-else v-for="division in divisions" :key="division.divisionId" class="px-2 py-1 text-sm rounded-full bg-green-100 text-green-800">
            {{ division.divisionName }}
          </span>
        </div>
      </template>
       <template #item-options="{ userid, username, roles, divisions, isactive }">
        <button 
          @click="editUser({ userid, username, roles, divisions, isactive })" 
          class="mx-2 hover:text-blue-900 p-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
          {{ t('usersPage.editButton') }}
        </button>
        <button 
          @click="openDeleteModal({ userid, username, roles, divisions })" 
          :disabled="userid === 1" 
          class="mx-2 hover:text-red-900 p-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          :class="{
            'text-indigo-700 bg-indigo-100 hover:bg-indigo-200': userid !== 1,
            'text-gray-400 bg-gray-100 cursor-not-allowed': userid === 1
          }"
          >
          {{ t('usersPage.deleteButton') }}
        </button>
      </template>
      <template #loading> 
        <ModernLoader />
      </template>
    </EasyDataTable>
      </div>
    </ThemeOnly>
  </div>



  <it-modal v-model="isDeleteModalOpen">
  <div class="p-4">
    <h2 class="text-2xl font-bold mb-4">{{ t('usersPage.deleteModalTitle') }}</h2>
  {{ t('usersPage.deleteModalConfirmText') }}

  <div class="flex justify-end mt-6">
            <button @click="isDeleteModalOpen=false" type="button" class="mr-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                {{ t('usersPage.cancelButton') }}
            </button>
            <button @click="deleteUser()" type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                {{ t('usersPage.confirmDeleteButton') }}
            </button>
        </div>
  </div>
  
</it-modal>

<it-modal v-model="isLimitReachedModalOpen">
    <div class="p-4 text-center">
      <div class="flex justify-center mb-4">
        <svg class="w-12 h-12 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
      </div>
      <h2 class="text-2xl font-bold mb-4">{{ t('usersPage.limitReachedModal.title', 'Limit Reached') }}</h2>
      <p>{{ t('usersPage.limitReachedModal.message', 'You have reached the maximum number of users for your organization.') }}</p>
      <p class="mt-2 text-base">{{ statusMaxUsers != null ? 'Max allowed users: ' + statusMaxUsers : 'Unlimited' }}</p>
      <div class="flex justify-center mt-6">
        <button @click="isLimitReachedModalOpen = false" class="btn">
          {{ t('usersPage.limitReachedModal.closeButton', 'Close') }}
        </button>
      </div>
    </div>
</it-modal>


<it-modal v-model="isUserModalOpen">
  <div class="flex items-center justify-center px-4">
    <div class="p-1s max-w-2xl w-full" style="z-index:1000">
      <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4 max-h-[80vh] overflow-y-auto">
        <div class="flex items-center justify-between mb-6">
          <h3 class="text-2xl font-bold text-gray-900 dark:text-gray-100"
            :class="{ 'text-right dir-rtl': isRTL === true }">
            {{ isEditingUser === true ? t('usersPage.userModalEditTitle') : t('usersPage.userModalAddTitle') }}
          </h3>
          <div class="flex items-center space-x-2">
            <span class="px-3 py-1 text-sm font-medium rounded-full" 
              :class="isEditingUser === true ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'">
              {{ isEditingUser === true ? t('usersPage.editModeBadge') : t('usersPage.createModeBadge') }}
            </span>
          </div>
        </div>
        
        <div class="space-y-6">
          <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              :class="{ 'text-right dir-rtl': isRTL === true }">
              {{ t('usersPage.userNameLabel') }}
            </label>
            <input v-model="userForm.userName" 
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:text-white" 
              type="text" required
              :placeholder="t('usersPage.userNamePlaceholder')">
          </div>

          <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              :class="{ 'text-right dir-rtl': isRTL === true }">
              {{ t('usersPage.emailLabel', 'Email') }}
            </label>
            <input v-model="userForm.email" 
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:text-white" 
              type="email" required
              :placeholder="t('usersPage.emailPlaceholder', 'user@company.com')">
          </div>
          
          <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              :class="{ 'text-right dir-rtl': isRTL === true }">
              {{ t('usersPage.passwordLabel') }} {{ isEditingUser === true ? t('usersPage.passwordEditHint') : '' }}
            </label>
            <input v-model="userForm.password" 
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:text-white" 
              type="password" required
              :placeholder="t('usersPage.passwordPlaceholder')">
            <p v-if="passwordError !== ''" class="text-red-500 text-sm mt-1" :class="{ 'text-right': isRTL }">{{ passwordError }}</p>
          </div>

          <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              :class="{ 'text-right dir-rtl': isRTL === true }">
              {{ t('usersPage.rolesLabel') }} {{ isEditingUser === true && selectedUserId === 1 ? t('usersPage.rolesAdminHint') : '' }}
            </label>
            <div class="max-h-60 overflow-y-auto space-y-2"
                 :class="{ 'opacity-50 pointer-events-none': isEditingUser === true && selectedUserId === 1 }">
              <div v-for="role in availableRoles" :key="role.roleid" 
                class="flex items-center p-2 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg transition-colors">
                <input type="checkbox" 
                  :id="'role-' + role.roleid"
                  v-model="userForm.roleIds"
                  :value="role.roleid"
                  :disabled="isEditingUser && selectedUserId === 1"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                <label :for="'role-' + role.roleid" 
                  class="ml-3 block text-sm text-gray-900 dark:text-gray-300">
                  {{ role.rolename }}
                </label>
              </div>
            </div>
          </div>

          <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              :class="{ 'text-right dir-rtl': isRTL === true }">
              {{ t('usersPage.divisionsLabel') }}
            </label>
            <div class="max-h-60 overflow-y-auto space-y-2">
              <div v-for="division in availableDivisions" :key="division.divisionId" 
                class="flex items-center p-2 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg transition-colors">
                <input type="checkbox" 
                  :id="'division-' + division.divisionId"
                  v-model="userForm.divisionIds"
                  :value="division.divisionId"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                <label :for="'division-' + division.divisionId" 
                  class="ml-3 block text-sm text-gray-900 dark:text-gray-300">
                  {{ division.divisionName }}
                </label>
              </div>
            </div>
          </div>

          <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <div class="form-control">
              <label class="label cursor-pointer">
                <span class="label-text font-medium w-full" :class="{ 'text-right dir-rtl': isRTL === true }">{{ t('usersPage.userStatusLabel') }}</span> 
                <input 
                  type="checkbox" 
                  v-model="userForm.isActive" 
                  class="toggle toggle-primary" 
                />
              </label>
               <div class="label">
                 <span class="label-text-alt">{{ userForm.isActive ? t('usersPage.userStatusActiveText') : t('usersPage.userStatusInactiveText') }}</span>
               </div>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200 dark:border-gray-700">
        <button @click="isEditingUser === true ? updateUser() : saveUser()" 
          class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
          {{ isEditingUser === true ? t('usersPage.updateUserButton') : t('usersPage.createUserButton') }}
        </button>
        <button @click="closeUserModal()" 
          class="mr-3 inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-gray-600 dark:text-gray-300 dark:border-gray-500 dark:hover:bg-gray-500">
          {{ t('usersPage.cancelButton') }}
        </button>
      </div>
    </div>
  </div>
</it-modal>

</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
table {
  font-family: "Heebo", sans-serif !important;
}
</style>
<script setup>
import { ref, onMounted, reactive, computed } from 'vue';
import EasyDataTable from "vue3-easy-data-table";
import Multiselect from '@vueform/multiselect'
import { SelectPageList } from 'v-selectpage'
import { cond } from 'lodash';
import PasswordInputField from '@/components/PasswordInputField.vue' 
import { useRouter } from 'vue-router';
import { globalState } from '@/globalState';
import { useToast } from 'vue-toastification'; 
import { useI18n } from '@/i18n';
import isDefinedAndNotEmpty from '../../isDefinedAndNotEmpty.js';
import ModernLoader from '@/components/ModernLoader.vue';
import ThemeOnly from '@/components/ThemeOnly.vue';
import { getLogger } from '@/shared/tools/logService.js';

const { t, currentLanguage } = useI18n();
const toast = useToast(); 
const log = getLogger('Users.vue');
const isUserModalOpen = ref(false);
const isDeleteModalOpen = ref(false);
const isLimitReachedModalOpen = ref(false);
const statusMaxUsers = ref(null);
const searchFields = ["userName", "roles"];
const searchValue = ref("");

const isEditingUser = ref(false);
const selectedUserId = ref(null);
const availableRoles = ref([]);
const availableDivisions = ref([]);

const userForm = reactive({
  userName: '',
  password: '',
  email: '',
  roleIds: [],
  divisionIds: [],
  isActive: true
});

const passwordError = ref('');

const headers = [
  { text: t('usersPage.tableHeaders.id'), value: "userid", sortable: true },
  { text: t('usersPage.tableHeaders.userName'), value: "username", sortable: true },
  { text: t('usersPage.tableHeaders.status'), value: "isactive", sortable: true },
  { text: t('usersPage.tableHeaders.roles'), value: "roles" },
  { text: t('usersPage.tableHeaders.divisions'), value: "divisions" },
  { text: t('usersPage.tableHeaders.options'), value: "options" }
];

const users = ref([]);

const canCreateUser = computed(() => statusMaxUsers.value == null || users.value.length < statusMaxUsers.value);

const router = useRouter();

const isRTL = computed(() => currentLanguage.value === 'he' || currentLanguage.value === 'ar');

const passwordStrengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()_+\-={}\[\]|\\:\";'<>?,./]).{8,}$/;

function showAlert(message, type = 'error') {
  if (type === 'success') {
    toast.success(message);
  } else {
    toast.error(message);
  }
}

async function loadUsers() {
  try {
    const response = await fetch(`${globalState.apiEndpoint}/api/users`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (response.ok === true) {
      const data = await response.json();
      statusMaxUsers.value = data.maxUsers;
      users.value = data.users.map(user => {
        const normalizedUserId = user.userid != undefined ? user.userid : (user.userId != undefined ? user.userId : user.id);
        const normalizedIsActive = user.isactive != undefined ? user.isactive : user.isActive;
        return {
          userid: normalizedUserId,
          username: user.username,
          email: user.email != undefined ? user.email : null,
          isactive: normalizedIsActive,
          roles: user.roles != undefined && user.roles.length > 0 ? user.roles.map(role => ({
            roleid: role.roleId != undefined ? role.roleId : role.roleid,
            rolename: role.roleName != undefined ? role.roleName : role.rolename
          })) : [],
          divisions: user.divisions != undefined && user.divisions.length > 0 ? user.divisions.map(division => ({
            divisionId: division.divisionId != undefined ? division.divisionId : division.divisionid,
            divisionName: division.divisionName != undefined ? division.divisionName : division.divisionname
          })) : []
        };
      });
    } else {
      const error = await response.json();
      showAlert(isDefinedAndNotEmpty(error.reason) != false ? error.reason : t('usersPage.toasts.loadUsersError'));
    }
  } catch (error) {
    showAlert(t('usersPage.toasts.loadUsersErrorPrefix') + error.message);
  }
}

async function loadRoles() {
  try {
    const response = await fetch(`${globalState.apiEndpoint}/api/roles/getAllRoles`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (response.ok === true) {
      const data = await response.json();
      availableRoles.value = data.map(role => ({
        roleid: role.roleId,
        rolename: role.roleName
      }));
    } else {
      const error = await response.json();
      showAlert(isDefinedAndNotEmpty(error.reason) != false ? error.reason : t('usersPage.toasts.loadRolesError'));
    }
  } catch (error) {
    showAlert(t('usersPage.toasts.loadRolesErrorPrefix') + error.message);
  }
}

async function loadDivisions() {
  try {
    const response = await fetch(`${globalState.apiEndpoint}/api/divisions/getAllDivisions`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (response.ok === true) {
      const data = await response.json();
      const list = Array.isArray(data) === true ? data : (Array.isArray(data?.divisions) === true ? data.divisions : []);
      availableDivisions.value = list.map(division => ({
        divisionId: division.divisionId != undefined ? division.divisionId : (division.divisionid != undefined ? division.divisionid : division.id),
        divisionName: division.divisionName != undefined ? division.divisionName : (division.divisionname != undefined ? division.divisionname : division.name)
      }));
    } else {
      const error = await response.json();
      showAlert(isDefinedAndNotEmpty(error.reason) != false ? error.reason : t('usersPage.toasts.loadDivisionsError'));
    }
  } catch (error) {
    showAlert(t('usersPage.toasts.loadDivisionsErrorPrefix') + error.message);
  }
}

async function saveUser() {
  try {
    if (passwordStrengthRegex.test(userForm.password) === false) {
      passwordError.value = t('usersPage.passwordComplexityError');
      return;
    } else {
      passwordError.value = '';
    }
    const response = await fetch(`${globalState.apiEndpoint}/api/users`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({
        username: userForm.userName,
        password: userForm.password,
        email: userForm.email,
        roleIds: userForm.roleIds,
        divisionIds: userForm.divisionIds,
        isActive: userForm.isActive
      })
    });
    
    if (response.ok === true) {
      showAlert(t('usersPage.toasts.createUserSuccess'), 'success');
      await loadUsers();
      closeUserModal();
    } else {
      const error = await response.json();
      if (error.error === 'Maximum number of users reached for this organization.') {
        closeUserModal();
        try {
          const statusResponse = await fetch(`${globalState.apiEndpoint}/api/users/status`, { headers: getAuthHeaders(), credentials: 'include' });
          if (statusResponse.ok === true) {
            const statusData = await statusResponse.json();
            statusMaxUsers.value = statusData.maxUsers;
          }
        } catch {}
        isLimitReachedModalOpen.value = true;
      } else {
        showAlert(isDefinedAndNotEmpty(error.reason) != false ? error.reason : t('usersPage.toasts.createUserError'));
      }
    }
  } catch (error) {
    showAlert(t('usersPage.toasts.createUserErrorPrefix') + error.message);
  }
}

async function updateUser() {
  try {
    if (userForm.password !== undefined && userForm.password !== null) {
      if (userForm.password.length > 0 && passwordStrengthRegex.test(userForm.password) === false) {
        passwordError.value = t('usersPage.passwordComplexityError');
        return;
      }
    }
    passwordError.value = '';
    const response = await fetch(`${globalState.apiEndpoint}/api/users/${selectedUserId.value}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({
        username: userForm.userName,
        password: userForm.password,
        email: userForm.email,
        roleIds: userForm.roleIds,
        divisionIds: userForm.divisionIds,
        isActive: userForm.isActive
      })
    });
    
    if (response.ok === true) {
      showAlert(t('usersPage.toasts.updateUserSuccess'), 'success');
      await loadUsers();
      closeUserModal();
    } else {
      const error = await response.json();
      showAlert(isDefinedAndNotEmpty(error.reason) != false ? error.reason : t('usersPage.toasts.updateUserError'));
    }
  } catch (error) {
    showAlert(t('usersPage.toasts.updateUserErrorPrefix') + error.message);
  }
}

async function deleteUser() {
  try {
    const response = await fetch(`${globalState.apiEndpoint}/api/users/${selectedUserId.value}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    
    if (response.ok === true) {
      showAlert(t('usersPage.toasts.deleteUserSuccess'), 'success');
      await loadUsers();
      isDeleteModalOpen.value = false;
    } else {
      const error = await response.json();
      showAlert(isDefinedAndNotEmpty(error.reason) != false ? error.reason : t('usersPage.toasts.deleteUserError'));
    }
  } catch (error) {
    showAlert(t('usersPage.toasts.deleteUserErrorPrefix') + error.message);
  }
}

async function openUserModal() {
  await loadUsers();
  if (statusMaxUsers.value != null && users.value.length >= statusMaxUsers.value) {
    isLimitReachedModalOpen.value = true;
  } else {
    isEditingUser.value = false;
    userForm.userName = '';
    userForm.password = '';
    userForm.roleIds = [];
    userForm.divisionIds = [];
    userForm.isActive = true;
    passwordError.value = '';
    isUserModalOpen.value = true;
  }
}

function closeUserModal() {
  isUserModalOpen.value = false;
  userForm.userName = '';
  userForm.password = '';
  userForm.email = '';
  userForm.roleIds = [];
  userForm.divisionIds = [];
  userForm.isActive = true;
  passwordError.value = '';
}

function openDeleteModal(user) {
  selectedUserId.value = user.userid;
  userForm.userName = user.username;
  userForm.email = user.email;
  userForm.roleIds = user.roles.map(role => role.roleid);
  userForm.divisionIds = user.divisions != undefined && user.divisions.length > 0 ? user.divisions.map(division => division.divisionId) : [];
  userForm.isActive = user.isactive;
  isDeleteModalOpen.value = true;
}

function editUser(user) {
  selectedUserId.value = user.userid;
  userForm.userName = user.username;
  userForm.email = user.email;
  userForm.roleIds = user.roles.map(role => role.roleid);
  userForm.divisionIds = user.divisions != undefined && user.divisions.length > 0 ? user.divisions.map(division => division.divisionId) : [];
  log.debug('Editing user object:', user);
  log.debug(`Value and type of user.isactive: ${user.isactive}, ${typeof user.isactive}`);
  userForm.isActive = user.isactive; 
  isEditingUser.value = true;
  isUserModalOpen.value = true;
}

function getAuthToken() {
  const authToken = document.cookie.split('; ').find(row => row.startsWith('authToken=') != false)?.split('=')[1];
  const jwtToken = document.cookie.split('; ').find(row => row.startsWith('jwtToken=') != false)?.split('=')[1];
  const token = authToken !== undefined && authToken !== null && authToken !== '' ? authToken : jwtToken;
  if (token === undefined || token === null) {
    return '';
  }
  return token;
}

function getAuthHeaders() {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json'
  };
  if (token !== '' && token !== undefined && token !== null) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

onMounted(() => {
  loadUsers();
  loadRoles();
  loadDivisions();
});
</script>
